<template>
  <LoginLayout>
    <jet-authentication-card>
      <jet-validation-errors class="mb-4 px-6 pt-4" />
      <div class="flex justify-around relative mr-10 ml-10 mt-5">
        <h3 class="text-gray-900 text-l font-medium mt-1">
          Login as Attendee
          <img class="absolute right-0 top-0" src="/image/icons/users-icon.svg" alt="users-icon" />
        </h3>
      </div>
      <div v-if="status" class="mb-4 px-6 font-medium text-sm text-green-600">
        {{ status }}
      </div>

      <form @submit.prevent="submit" class="p-6 pt-3 relative">
        <div>
          <jet-label for="email" value="Email" />
          <jet-input
            data-cy="user-email"
            id="email"
            type="email"
            name="email"
            class="mt-1 block w-full"
            v-model="form.email"
            required
            autofocus
            autocomplete="on"
          />
        </div>

        <div class="mt-4">
          <jet-label for="password" value="Password" />
          <jet-input
            data-cy="user-password"
            id="password"
            :type="fieldType"
            class="mt-1 block w-full focus: red"
            name="password"
            v-model="form.password"
            required
            autocomplete="current-password"
          />
          <TogglePassword
            @fieldTypeChanged="fieldTypeChanged"
            :password="form.password"
          ></TogglePassword>
        </div>

        <div class="flex items-center justify-between mt-4">
          <label class="flex items-center">
            <jet-checkbox name="remember" v-model:checked="form.remember" style="color: #3730a3" />
            <span class="ml-2 text-sm text-gray-600">Remember me</span>
          </label>
          <div class="text-sm">
            <inertia-link
              data-cy="user-forgot-password"
              v-if="canResetPassword"
              :href="route('password.request')"
              class="font-medium text-vice-teal-700 hover:text-vice-teal-600 text-sm"
              style="color: #3730a3"
            >
              Forgot your password?
            </inertia-link>
          </div>
        </div>

        <div class="flex items-center justify-end mt-4">
          <jet-button
            data-cy="user-login"
            class="w-full flex justify-center py-2.5"
            :class="{ 'opacity-25': form.processing }"
            :disabled="form.processing"
            style="color: #3730a3; background: #e0e7ff; letter-spacing: 0; text-transform: none"
          >
            Log in
          </jet-button>
        </div>
        <div class="mt-2 text-center">
          <inertia-link
            data-cy="user-no-account-register"
            :href="route('register')"
            class="font-medium text-vice-teal-700 hover:text-vice-teal-600 text-sm"
            style="color: #8886a6"
          >
            Don't have an account yet? Click here to register
          </inertia-link>
        </div>
      </form>
    </jet-authentication-card>
  </LoginLayout>
</template>

<script>
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue';
import JetButton from '@/Jetstream/Button.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetCheckbox from '@/Jetstream/Checkbox.vue';
import JetLabel from '@/Jetstream/Label.vue';
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue';
import TogglePassword from '@/Components/Badges/TogglePassword.vue';
import LoginLayout from '../../Layouts/LoginLayout.vue';

export default {
  components: {
    JetAuthenticationCard,
    JetButton,
    JetInput,
    JetCheckbox,
    JetLabel,
    JetValidationErrors,
    TogglePassword,
    LoginLayout,
  },
  props: {
    canResetPassword: Boolean,
    status: String,
  },
  data() {
    return {
      form: this.$inertia.form({
        email: '',
        password: '',
        remember: false,
        processing: false,
      }),
      fieldType: 'password',
    };
  },
  methods: {
    submit() {
      this.form.processing = true;
      this.$inertia
        .post(
          this.route('login'),
          {
            email: this.form.email,
            password: this.form.password,
            remember: this.form.remember ? 'on' : '',
          },
          {
            replace: true,
          },
        )
        .then(() => {
          this.form.processing = false;
          this.form.reset('password');
        })
        .catch((error) => {
          console.error(error);
          this.form.processing = false;
          this.form.reset('password');
        });
    },
    fieldTypeChanged(e) {
      this.fieldType = e;
    },
  },
};
</script>
